<template>
	<div>
		<ts-page-title :title="$t('additionalInfo.pageTitle')" :breadcrumb="[
			{ text: $t('home'), href: '/' },
			{
				text: $t('additionalInfo.pageTitle'),
				active: true,
			},
		]" />
		<ts-panel>
			<ts-panel-wrapper>
				<div class="row">
					<div class="col-md-2 form-group ts-px-2">
						<label class="form-col-label control-label required ts-mb-2">{{
							$t('additionalInfo.dateFrom')
						}}</label>
						<DatePicker style="width: 100%;" :value="dateFrom" @on-change="onChangeDateFrom" format="dd-MM-yyyy"
							type="date" :class="{
								'ivu-form-item-error': errors.has('date_from'),
							}" />
						<div class="ivu-form-item-error ts-text-red-600" v-if="errors.has('date_from')">
							{{ errors.first('date_from') }}
						</div>
					</div>
					<div class="col-md-2 form-group ts-px-2">
						<label class="form-col-label control-label required ts-mb-2">{{
							$t('additionalInfo.dateTo')
						}}</label>
						<DatePicker style="width: 100%;" :value="dateTo" @on-change="onChangeDateTo" format="dd-MM-yyyy"
							type="date" :class="{
								'ivu-form-item-error': errors.has('date_to'),
							}" />
						<div class="ivu-form-item-error ts-text-red-600" v-if="errors.has('date_to')">
							{{ errors.first('date_to') }}
						</div>
					</div>
					<div class="col-md-2 form-group ts-px-2">
						<label class="form-col-label control-label ts-mb-2">{{
							$t('additionalInfo.warehourse')
						}}</label>
						<a-select v-model="model.location_id" mode="multiple" :defaultActiveFirstOption="true" showSearch
							:filterOption="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								" :options="locations" :placeholder="$t('all')" class="ts-w-full"></a-select>
					</div>
					<div class="col-md-2 form-group ts-px-2">
						<label class="form-col-label control-label ts-mb-4"></label>
						<ts-input v-model="search" :placeholder="$t('search')" style="width: 100%;" class="inline-block" />
					</div>
					<div class="col-md-2 form-group ts-px-2 ts-pt-6">
						<Button :disabled="loading" :loading="loading" class="ts-mb-1" type="primary" @click="fetchData">{{
							$t('view') }}
						</Button>
						<Button class="ts-mb-1 ts-ml-3" type="success" :disabled="exporting" :loading="exporting" ghost
							@click="exportExcel">
							<Icon type="ios-document-outline" />
							{{ $t('excel') }}
						</Button>
					</div>
				</div>
			</ts-panel-wrapper>
			<ts-table :columns="columns" :records="resources" :loading="loading" max-height="700" border :rowGroup="{
				field: 'title_serial'
			}">
				<template v-slot="{ record }">
					<td class="ts-whitespace-no-wrap">{{ record.location_name_en }}</td>
					<td class="ts-whitespace-no-wrap ts-text-center">{{ record.barcode }}</td>
					<td class="ts-whitespace-no-wrap">{{ record.product_name_en }}</td>
					<td class="ts-whitespace-no-wrap ts-text-center">{{ record.sex }}</td>
					<td class="ts-whitespace-no-wrap">{{ record.color }}</td>
					<td class="ts-whitespace-no-wrap">{{ record.imei }}</td>
					<td class="ts-whitespace-no-wrap ts-text-center">{{ record.additional_date_format }}</td>
					<td class="ts-whitespace-no-wrap">{{ record.remarks }}</td>
					<td class="ts-whitespace-no-wrap">{{ record.employee_name_en }}</td>
					<td class="ts-whitespace-no-wrap">{{ record.created_date }}</td>
				</template>
			</ts-table>
			<div class="ts-flex ts-items-center ts-justify-end ts-p-4">
				<ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
			</div>
		</ts-panel>
	</div>
</template>
  
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'
import * as FileDownload from 'downloadjs'
import { trim, debounce } from 'lodash'

export default {
	name: 'report-additional-info',
	components: {},
	data() {
		return {
			errors: new Errors(),
			loading: false,
			exporting: false,
			locationLoading: false,
			dateFrom: moment().startOf('month').format('DD-MM-YYYY'),
			dateTo: moment().endOf('month').format('DD-MM-YYYY'),
			locations: [],
			model: {
				location_id: [this.$store.state.authUser.user.default_location.location_id],
			}
		}
	},
	computed: {
		...mapState('report/additionalInfo', [
			'resources',
			'pagination',
		]),
		search: {
			get() {
				return this.$store.state.report.additionalInfo.search
			},
			set(newValue) {
				this.$store.commit('report/additionalInfo/SET_SEARCH', newValue)
				this.$store.commit('report/additionalInfo/RESET_CURRENT_PAGE')
			}
		},
		columns() {
			return [
				{
					name: this.$t('additionalInfo.warehourse')
				},
				{
					name: this.$t('additionalInfo.barcode'),
					style: 'text-align: center'
				},
				{
					name: this.$t('additionalInfo.productNameEn')
				},
				{
					name: this.$t('additionalInfo.sex'),
					style: 'text-align: center'
				},
				{
					name: this.$t('additionalInfo.color')
				},
				{
					name: this.$t('additionalInfo.imeiCode')
				},
				{
					name: this.$t('additionalInfo.additionalInfoDate'),
					style: 'text-align: center'
				},
				{
					name: this.$t('additionalInfo.remarks')
				},
				{
					name: this.$t('additionalInfo.createdBy')
				},
				{
					name: this.$t('additionalInfo.createdDate')
				}
			]
		},
	},
	created() {
		this.fetchResource()
	},
	methods: {
		async fetchResource() {
			this.loading = true
			await this.$store
				.dispatch('report/resource/getLocation')
				.then((response) => {
					this.locations = response.data.map((el) => ({
						value: el.location_id,
						label: el.location_name_en,
					}))
				})
			this.loading = false
		},
		onChangeDateFrom(data) {
			this.dateFrom = data
		},
		onChangeDateTo(data) {
			this.dateTo = data
		},
		async fetchData(attributes) {
			this.loading = true
			this.errors = new Errors()
			this.$store
				.dispatch('report/additionalInfo/fetch', {
					date_from: this.dateFrom,
					date_to: this.dateTo,
					location_id: this.model.location_id,
					...attributes,
				})
				.then(() => {
					this.loading = false
				})
				.catch((error) => {
					this.loading = false
					this.errors = new Errors(error.errors)
					this.notice({ type: 'error', text: error.message })
				})
		},
		exportExcel() {
			this.exporting = true
			this.errors = new Errors()
			this.$store
				.dispatch('report/additionalInfo/additionalInfoExcel', {
					date_from: this.dateFrom,
					date_to: this.dateTo,
					location_id: this.model.location_id,
				})
				.then((response) => {
					let filename = trim(
						response.headers['content-disposition']
							.substring(
								response.headers['content-disposition'].indexOf('filename')
							)
							.replace('filename=', ''),
						'"'
					)
					FileDownload(response.data, filename)
				})
				.catch((err) => {
					let error = JSON.parse(
						String.fromCharCode.apply(null, new Uint8Array(err))
					)
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => (this.exporting = false))
		},
		notice(not) {
			this.$Notice[not.type]({
				title: 'DAILY ATTENDANCES',
				desc: not.text,
			})
		},
	},
	watch: {
		search: debounce(function (search) {
			this.fetchData()
		}, 500)
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.fetchResource()
		})
	},
}
</script>
  